import bqs from './basic-questions'
import faker from 'faker'

/**
 * http://192.168.1.56:3000/project/130/interface/api/3213
 **/
const genItem = (scope, idx) => {
  const inputTypes = [2, 3, 99]
  const subType = inputTypes[Math.floor(Math.random() * inputTypes.length)]
  const alphaLetters = 'ABCDEFGHI'.split('')
  let ll = Math.floor(Math.random() * alphaLetters.length)
  ll = ll < 2 ? 3 : ll
  const questions = alphaLetters.slice(0, ll).map((alpha, idx) => {
    return {
      subCode: alpha,
      option: alpha,
      subTitle: faker.lorem.slug(),
      score: 666 + idx
    }
  })

  return {
    code: idx, // identity
    type: 2, // 测评内容类型：1-基础题目；2-测评题目；3-测评标准结果；
    subType: subType, // 题目类型(主要针对type=2)： 2-选择题；3-填空题；4-下拉选择题
    sort: 1,
    title: faker.lorem.words(),
    question: questions
  }
}

const assessQuestion = Array.from(Array(1)).map(genItem)

export default {
  data: [
    ...bqs.data.baseQuestion,
    ...assessQuestion
  ]
}
